<template>
  <v-dialog v-model="certificatesActivateModal" persistent width="500">
    <v-card tile>
      <v-card-title class="headline">{{ $t('certificatesActivation') }}</v-card-title>
      <v-card-text>
        <div class="d-flex flex-column align-sm-center flex-sm-row">
          <v-text-field
              :label="$t('certificatesUUID') + ' *'"
              required
              v-model="certificate.seller"
              class="mt-4"
              :error-messages="sellerErrors"
              @input="$v.certificate.seller.$touch()"
              @blur="$v.certificate.seller.$touch()"
          ></v-text-field>

          <v-checkbox
              v-model="isUIDFilled"
              class="ml-2"
              @change="handleCheckboxChange"
              :label="$t('certificatesSeller')"
          ></v-checkbox>
        </div>
        <v-text-field
            v-model="certificate.name"
            :label="$t('BAFormName') + ' *'"
            type="text"
            required
            :error-messages="nameErrors"
            @input="$v.certificate.name.$touch()"
            @blur="$v.certificate.name.$touch()"
        ></v-text-field>
        <v-text-field
            v-model="certificate.phone"
            :label="$t('BAFormPhone') + ' *'"
            type="text"
            required
            :error-messages="phoneErrors"
            @input="$v.certificate.phone.$touch()"
            @blur="$v.certificate.phone.$touch()"
        ></v-text-field>
        <v-text-field
            v-model="certificate.email"
            :label="'E-mail' + ' *'"
            type="text"
            :error-messages="emailErrors"
            @blur="$v.certificate.email.$touch()"
        ></v-text-field>
        <small>* {{ $t("validation") }}</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="closeForm()">{{
          $t("btnExit")
        }}</v-btn>
        <v-btn
          color="green darken-1"
          text
          @click="submitForm()"
          :disabled="$v.certificate.$invalid"
          >{{ $t("certificatesActivate") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import { validationMixin } from "vuelidate";
import {required, email, helpers} from "vuelidate/lib/validators";

const phoneValid = (value) => {
  return value ? true : false;
};
const sellerValid = (value) => {
  return value ? true : false;
};
const phoneRegexp = helpers.regex("phone", /^\+?[0-9]+$/);

export default {
  name: "CertificatesActivateModal",

  mixins: [validationMixin],

  props: ["certificatesActivateModal", "uniqueCode"],

  data() {
    return {
      certificate: {
        seller: null,
        name: null,
        phone: null,
        email: null,
        location_id: null
      },
      isUIDFilled: false,
      phoneValid: true,
      sellerValid: true,
    };
  },

  validations: {
    certificate: {
      seller: {
        required,
      },
      name: {
        required,
      },
      phone: {
        required,
        phoneRegexp,
      },
      email: {
        required,
        email,
      },
    },
    phoneValid: {
      phoneValid,
    },
    sellerValid: {
      sellerValid,
    },
  },

  computed: {
    ...mapGetters(["currentUser", "location"]),
    sellerErrors() {
      const errors = [];
      if (!this.$v.certificate.seller.$dirty) return errors;
      !this.$v.certificate.seller.required &&
        errors.push(this.$i18n.t("validationRequired"));
      !this.$v.sellerValid.sellerValid &&
      errors.push(this.$i18n.t("validationSeller"));
      return errors;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.certificate.name.$dirty) return errors;
      !this.$v.certificate.name.required &&
      errors.push(this.$i18n.t("validationRequired"));
      return errors;
    },
    phoneErrors() {
      const errors = [];
      if (!this.$v.certificate.phone.$dirty) return errors;
      !this.$v.certificate.phone.required &&
      errors.push(this.$i18n.t("validationRequired"));
      !this.$v.certificate.phone.phoneRegexp &&
      errors.push(this.$i18n.t("validationPhone"));
      !this.$v.phoneValid.phoneValid &&
      errors.push(this.$i18n.t("validationPhone"));
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.certificate.email.$dirty) return errors;
      !this.$v.certificate.email.required &&
      errors.push(this.$i18n.t("validationRequired"));
      !this.$v.certificate.email.email &&
      errors.push(this.$i18n.t("validationEmail"));
      return errors;
    },
  },

  methods: {
    ...mapActions(["certificateActivation"]),
    submitForm() {
      const payload = { ...this.certificate, location_id: this.location.id }
      this.certificateActivation({ code: this.uniqueCode, payload })
          .then(() => {
        this.clearCertificate();
        this.$emit("reload-certificates");
        this.$emit("close-dialog");
      })
          .catch((error) => {
        this.phoneValid = !error.response.data.phone;
        this.$v.phoneValid.$touch();
        this.sellerValid = !error.response.data.seller;
        this.$v.sellerValid.$touch();
      });
    },
    closeForm() {
      this.clearCertificate();
      this.$emit("close-dialog");
    },
    clearCertificate() {
      this.certificate = {
        seller: null,
        name: null,
        phone: null,
        email: null,
      };
      this.phoneValid = true;
      this.isUIDFilled = false;
    },
    handleCheckboxChange(value) {
      if (value) {
        this.certificate.seller = this.currentUser.uid;
      } else {
        this.certificate.seller = '';
      }
    }
  },

  watch: {
    certificatesActivateModal(visible) {
      if (!visible) {
        this.$v.$reset();
      }
    },
  },
};
</script>
